export const postTextarea = {
  flex: "1",
  size: "lg",
  resize: "none",
  borderRadius: "md",
  focusBorderColor: "blue.400",
  placeholder: "Write a caption...",
  maxLength: 2200,
};

export const imageCrossButton = {
  position: "absolute",
  fontSize: "1.5rem",
  right: "3rem",
  cursor: "pointer",
};
